import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CtaSection.module.css';

import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import StartButton from '../shared/start-button/StartButton';
import image from './images/Group 9.png';

const CtaSection: React.FC = () => {
    const navigate = useNavigate();

    const handleRequestDemo = () => {
        navigate('/contact');
    };

    return (
        <div className={styles.container}>
            <div className={styles.bgBox}>
                <div className={styles.contentBox}>
                    <OptimizedMotionH2 className={styles.title} type="slide-down" delay={0.3}>
                        Ready to simplify your content workflow?
                    </OptimizedMotionH2>
                    <OptimizedMotionP className={styles.subtitle} type="slide-right" delay={0.6}>
                        Let your team focus on bold ideas, strategy, and creativity while
                        <br />
                        SimpleeCreate takes care of the heavy lifting.
                    </OptimizedMotionP>

                    <StartButton className={styles.startBtn} />
                </div>
                {/* <div className={styles.image_container}>
                    <img src={image} alt="" className={styles.image} />
                </div> */}
            </div>
        </div>
    );
};

export default CtaSection;
